export const PastStationStatuses = {
	Approved: 'Approved',
	Alert: 'Alert',
	Rejected: 'Rejected',
	TimedOut: 'TimedOut',
} as const;
export const FutureStationStatuses = {
	// future status
	Waiting: 'Waiting',
} as const;
export const presentStationStatuses = {
	// present status
	InProcess: 'InProcess',
} as const;
export const StationStatusType = {
	// past statuses:
	...PastStationStatuses,
	// present statuses:
	...presentStationStatuses,
	// future statuses:
	...FutureStationStatuses,
} as const;
export type StationStatusType = (typeof StationStatusType)[keyof typeof StationStatusType];

// order for sorting parallel stations in vertical cycle flow
export enum StationStatusOrder {
	'Rejected' = 0,
	'Approved' = 1,
	'InProcess' = 2,
	'Waiting' = 3,
	'TimedOut' = 4,
	'Alert' = 5,
}
